import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import INFO_BEHAVIOUR_ON_HOVER from '../../common/constants/infoBehaviourOnHover';
import SCROLL_DIRECTION from '../../common/constants/scrollDirection';
import ARROWS_VERTICAL_POSITION from '../../common/constants/arrowsVerticalPosition';
import { calcTargetItemSize } from '../helpers/layoutHelper';
export var fixedStyles = {
    galleryLayout: LAYOUTS.SLIDESHOW,
    enableInfiniteScroll: true,
    cubeRatio: '100%/100%',
    cubeImages: true,
    oneRow: true,
    hoveringBehaviour: INFO_BEHAVIOUR_ON_HOVER.NEVER_SHOW,
    scrollDirection: SCROLL_DIRECTION.HORIZONTAL,
    galleryMargin: 0,
    isVertical: false,
    groupSize: 1,
    groupTypes: '1',
    arrowsVerticalPosition: ARROWS_VERTICAL_POSITION.IMAGE_CENTER,
    itemBorderWidth: 0,
    itemBorderRadius: 0,
    itemBorderColor: undefined,
    // this params were moved from the presets in layoutHelper and were not tested and checked yet.
    smartCrop: false,
    targetItemSize: 550,
    galleryType: 'Strips',
    fixedColumns: 1,
    hasThumbnails: false,
    enableScroll: true,
    scrollSnap: true,
    isGrid: false,
    isColumns: false,
    isMasonry: false,
    isSlider: false,
    isSlideshow: true,
    cropOnlyFill: false,
    scatter: 0,
    rotatingScatter: '',
    imageMargin: 0,
};
export var createStyles = function (styles) {
    return __assign(__assign(__assign({}, styles), fixedStyles), { targetItemSize: calcTargetItemSize(styles) });
};
//# sourceMappingURL=slideshowGallery.js.map